<template>
  <div class="logo">
    <div class="imgUrl">
      <a title="雅昌艺术网" href="https://www.artron.net/"></a>
    </div>
    <div class="title">
      雅昌拍卖
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  align-items: center;
  padding: 32px 0px 29px;
  .imgUrl {
    width: 46px;
    height: 43px;
    cursor: pointer;
    background-image: url("./img/logo.png");
    a {
      width: 100%;
      height: 100%;
      display: inline-block;
    }
  }
  .title {
    margin-left: 10px;
    font-size: 30px;
    font-weight: bold;
    font-family: Microsoft Yahei;
  }
}
</style>
